import { render, staticRenderFns } from "./FmTagDemo.vue?vue&type=template&id=8fa3fd02&scoped=true&"
import script from "./FmTagDemo.vue?vue&type=script&lang=js&"
export * from "./FmTagDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3fd02",
  null
  
)

export default component.exports